import i18next, { t } from "i18next";
import { Alert, Button, Col, Form, Row, Stack } from "react-bootstrap";
import { OpportunityStageEnum, RoleEnum } from "src/api";
import OpportunityStagePicker from "./OpportunityStagePicker";
import { isNil } from 'lodash';
import OpportunitySmallPreview from "src/components/Opportunities/OpportunitySmallPreview/OpportunitySmallPreview";
import { useAuth } from "src/hooks/useAuth";

const allowedStages = [OpportunityStageEnum.proposal, OpportunityStageEnum.waiting_sign, OpportunityStageEnum.credit_score_check];

export function OpportunityPanel({
  funnelData,
  selectedOpportunityStage,
  setSelectedOpportunityStage,
  validateFn,
  validation,
  cleanOpportunityValues,
  setAccountModalOpened,
  setModalType,
  accountModalOpened,
  opportunityValues
}) {
  const { userRole } = useAuth();

  const onResetOpportunity = () => {
    validateFn()

    if (validation.opportunity) {
      cleanOpportunityValues();
      return;
    }

    setAccountModalOpened(true)
    setModalType('opportunity')
  }


  if (!funnelData.account) {
    return (
      <div>
        <Alert variant='secondary' className="mb-4">
          {t('account_selection_required_to_proceed')}
        </Alert>
      </div>
    )
  }

  return (
    <div>
      <Form autoComplete='off' onSubmit={() => { }}>
        <Row md={12}>
          <Col>
            <Stack direction="horizontal" gap={3} className="align-items-end">
              {userRole !== RoleEnum.SALES_DEALER && (
                <div>
                  <div className='me-4'>{i18next.t('state')}</div>
                  <OpportunityStagePicker
                    isDisabled={userRole === RoleEnum.SALES_DEALER}
                    defaultValue={selectedOpportunityStage}
                    onStageSelected={setSelectedOpportunityStage}
                    allowedStages={allowedStages}
                  />
                </div>
              )}

              <div>
                <Button
                  onClick={onResetOpportunity}
                  disabled={isNil(funnelData.account)}>
                  {validation.opportunity ? t('change') : `+ ${t('create_new')}`}
                </Button>
                {validation.opportunity && !opportunityValues.entity && (
                  <Button
                    variant='secondary'
                    className='ms-2'
                    onClick={() => {
                      setAccountModalOpened(true)
                      setModalType('opportunity')
                    }}>
                    {t('edit')}
                  </Button>
                )}
              </div>
            </Stack>
          </Col>


          <Col md={12}>
            <div>
              {!accountModalOpened && validation.opportunity && (
                <div className='mt-3'>
                  <OpportunitySmallPreview opportunity={opportunityValues} />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  )
}


export default OpportunityPanel;
